import React from 'react'
import { FaCanadianMapleLeaf } from 'react-icons/fa'
import styled from '@emotion/styled'

const Container = styled.div``

export function Footer() {
  return (
    <Container>
      <div>
        <FaCanadianMapleLeaf size={16} />
      </div>
    </Container>
  )
}
